/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */

import { useState } from 'react';
import Link from 'next/link';

import Layout from '../layout/Layout';
import ModalVideo from '../components/ui/ModalVideo';
import VideoImage from '../components/ui/VideoImage';

const TermsCookies = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Layout backLink="intranet" classNameBodyContainer="c-login__container">
      <ModalVideo
        isOpen={isOpen === 1}
        videoId="ioPsby6xsd4"
        handleClose={() => setIsOpen(false)}
      />
      <ModalVideo
        isOpen={isOpen === 2}
        videoId="iCw40YmZvzg"
        handleClose={() => setIsOpen(false)}
      />
      <ModalVideo
        isOpen={isOpen === 3}
        videoId="HZDGOKVtEr4"
        handleClose={() => setIsOpen(false)}
      />

      <ModalVideo
        isOpen={isOpen === 4}
        videoId="I9Uau34xD7g"
        handleClose={() => setIsOpen(false)}
      />

      <div className="c-help">
        <div className="c-help__content-table">
          <h2 className="c-help__content-title">Tabla de contenidos</h2>
          <h3 className="c-help__table-section-title">Usuario</h3>
          <ul>
            <li>
              <a href="#register" className="c-help__table-link">
                Registro
              </a>
            </li>
            <li>
              <a href="#restore-password" className="c-help__table-link">
                Restablecer Contraseña
              </a>
            </li>
          </ul>

          <h3 className="c-help__table-section-title">Eventos</h3>
          <ul>
            <li>
              <a href="#create-events" className="c-help__table-link">
                Crear, editar y eliminar eventos
              </a>
            </li>
          </ul>
        </div>
        <div className="c-help__content">
          <h1 className="c-help__title">
            Guía de uso de la plataforma para promotores
          </h1>

          <h2 className="c-help__section-title" id="register">
            Registro como promotor de eventos
          </h2>
          <p>
            Cualquier usuario puede registrarse como promotor en el apartado de
            login de la intranet, accesible a través del siguiente enlace:
          </p>
          <Link href="/login">
            <a>https://agendaelsports.es/login</a>
          </Link>
          <p>
            En el siguiente vídeo se muestra todo el proceso de registro y de
            validación para usuarios:
          </p>

          <VideoImage
            src="/img/ayuda/registro.png"
            alt="Video de ayuda para el registro de usuarios"
            onClick={() => {
              setIsOpen(1);
            }}
          />

          <h2 className="c-help__section-title" id="restore-password">
            Restablecer contraseña
          </h2>
          <p>
            ¿Has perdido o olvidado tu contraseña? Es muy sencillo recuperarla,
            puedes hacerlo desde la página de <Link href="/login">login</Link>,
            haciendo click en el botón de "¿Has olvidado tu contraseña?"
            encontrarás un formulario que te permitirá establecer una nueva
            contraseña.
          </p>
          <Link href="/login">
            <a>https://agendaelsports.es/login</a>
          </Link>
          <p>
            En el siguiente vídeo se realiza todo el proceso para restablecer la
            contraseña de forma rápida y sencilla:
          </p>
          <VideoImage
            src="/img/ayuda/contrasena.png"
            alt="Video de ayuda para el registro de usuarios"
            onClick={() => {
              setIsOpen(2);
            }}
          />

          <p>
            En caso de no recibir el correo electrónico para restablecer tu
            contraseña, ponte en contacto con nosotros a través del correo
            electrónico: info@agendaelsports.es
          </p>

          <h2 className="c-help__section-title" id="create-events">
            Crear, editar y eliminar eventos
          </h2>
          <p>
            Una vez registrado como promotor y tu perfil haya sido verificado,
            puedes publicar publicar eventos en el portal de la Agenda Virtual.
            Para ello puedes acceder a la intranet con tus credenciales a través
            de la página de login:
          </p>
          <Link href="/login">
            <a>https://agendaelsports.es/login</a>
          </Link>
          <br />
          <br />
          <div>
            <strong>Crear un evento</strong>
          </div>
          <p>
            Una vez dentro, sigue los siguientes pasos para crear tu primer
            evento:
          </p>
          <ul>
            <li>Haz click en el botón de "Nuevo Evento"</li>
            <li>
              Se abrirá un formulario para introducir toda la información sobre
              tu evento
            </li>
            <li>
              Añade la información sobre el evento (Título, Descripción,
              Fecha-Hora de inicio y de finalización...)
            </li>
            <li>
              Guarda los cambios y publica el evento, en la esquina inferior
              derecha se encuentra el botón de "Publicar".
            </li>
            <li>
              Si hemos introducido toda la información correctamente nos
              permitirá publicar el evento y veremos un mensaje de confirmación.
            </li>
            <li>
              El evento quedará pendiente de validación por el administrador.
            </li>
            <li>
              Una vez validado, recibiras un correo electrónico de confirmación
              avisandote que el evento ha sido validado y está público en el
              feed de la Agenda Virtual Els Ports
            </li>
          </ul>
          <br />
          <VideoImage
            src="/img/ayuda/crear-evento.png"
            alt="Video de ayuda para el crear eventos"
            onClick={() => {
              setIsOpen(3);
            }}
          />
          <br />

          <span>
            <strong>Editar un evento</strong>
          </span>
          <p>
            Para editar un evento, tendrás que localizar dicho evento en la
            intranet y hacer click en el enlace "Editar evento", así puedes
            editar cualquier campo y aplicar los cambios con el botón de
            "publicar" en la esquina inferior derecha.
          </p>
          <span>
            <strong>Eliminar un evento</strong>
          </span>
          <p>
            Para eliminar un evento, tendrás que localizar dicho evento en la
            intranet y hacer click en el enlace "Editar evento" y en la esquina
            inferior derecha encontraremos un botón que te permitirá eliminar el
            evento.
          </p>
          <br />
          <VideoImage
            src="/img/ayuda/eliminar.png"
            alt="Video de ayuda para el editar y eliminar eventos"
            onClick={() => {
              setIsOpen(4);
            }}
          />
          <br />
          <p>
            En caso de que el evento no sea validado, rogamos esperar almenos
            24h antes de contactar con el administrador, si transcurido ese
            plazo el evento no es validado y urge su publicación, puedes ponerte
            en contacto a través del email: info@agendaelsports.es
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default TermsCookies;
